import React, { useState, useContext } from 'react';
import { View, Text, Pressable } from 'react-native';
import { useMutation } from '@apollo/client';
import styled from 'styled-components/native';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCheck, faXmark, faDollarSign
} from '@fortawesome/free-solid-svg-icons';

import { currency } from 'app/src/utils/stringHelpers';

import Accept from './Accept';
import Counter from './Counter';
import { CREATE_FEE_ESTIMATE, UPDATE_FEE_ESTIMATE } from './queries';
import AuthContext from '../../../contexts/AuthContext';

const Container = styled(View)`
  flex-direction: row;
  width: 50%;
  justify-content: space-around;
`;

const EstimateFunctions = ({ feeEstimate, refetch, feeRefetch }) => {
  const { user } = useContext(AuthContext);
  const [showAcceptModal, setShowAcceptModal] = useState(false);
  const [showCounterModal, setShowCounterModal] = useState();
  const [createFeeEstimate] = useMutation(CREATE_FEE_ESTIMATE, {
    onCompleted: () => {
      if(refetch) refetch();
      if(feeRefetch) feeRefetch();
      setShowCounterModal(false);
    }
  });
  const [updateFeeEstimate] = useMutation(UPDATE_FEE_ESTIMATE, {
    onCompleted: () => {
      if(refetch) refetch();
      if(feeRefetch) feeRefetch();
      setShowAcceptModal(false);
      setShowCounterModal(false);
    }
  });

  const stockNumber = feeEstimate.asset.stockNumber;
  const amount = feeEstimate.amount;

  const acceptConfirm =
    `Click OK to ACCEPT this ${feeEstimate.type} counter amount of ${
      currency(amount)} for ${stockNumber}`;

  const accept = () => {
    if (confirm(acceptConfirm)) {
      updateFeeEstimate({
        variables: {
          id: feeEstimate.id,
          status: 'Accepted',
          acceptedByType: 'User',
          acceptedById: user?.id
        }
      });
    }
  };

  const declineConfirm =
    `Click OK to DECLINE this ${feeEstimate.type} counter of ${
      currency(feeEstimate.counterAmount)} for ${stockNumber}`;

  const decline = () => {
    if (confirm(declineConfirm)) {
      updateFeeEstimate({
        variables: {
          id: feeEstimate.id,
          status: 'Rejected'
        }
      });
    }
  };

  return (
    <>
      <Container style={{width: '100%'}}>
        <Pressable onPress={() => setShowAcceptModal(true)}>
          <FontAwesomeIcon
            icon={faCheck}
            color="green"
            size="lg"
            title="Accept"
          />
        </Pressable>
        <Pressable onPress={decline}>
          <FontAwesomeIcon
            icon={faXmark}
            color="red"
            size="lg"
            title="Decline"
          />
        </Pressable>
        <Pressable onPress={() => setShowCounterModal(true)}>
          <FontAwesomeIcon
            icon={faDollarSign}
            color="black"
            size="lg"
            title="Counter"
          />
        </Pressable>
      </Container>
      {showAcceptModal && (
        <Accept
          feeEstimate={feeEstimate}
          setShowModal={setShowAcceptModal}
          updateFeeEstimate={updateFeeEstimate}
        />
      )}
      {showCounterModal && (
        <Counter
          feeEstimate={feeEstimate}
          setShowModal={setShowCounterModal}
          createFeeEstimate={createFeeEstimate}
          updateFeeEstimate={updateFeeEstimate}
        />
      )}
    </>
  );
};

export default EstimateFunctions;
